import { ActionTypes } from "redux/reducers/sgcConfigurations/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { api_get, api_delete, api_put, api_post} from "services/api";

const {
  ADD_SGC_CONFIGURATION_MODE,
  EDIT_SGC_CONFIGURATION_MODE,
  DELETE_SGC_CONFIGURATION_MODE,
  OPEN_SGC_CONFIGURATION_SNACK,
  CLOSE_SGC_CONFIGURATION_SNACK,
  CREATE_SGC_CONFIGURATION,
  MOD_SGC_CONFIGURATION,
  DELETE_SGC_CONFIGURATION,
  CLEAR_SGC_CONFIGURATIONS,
  GET_SGC_CONFIGURATIONS,
  SET_SGC_CONFIGURATIONS_FILTERS,
  SGC_CONFIGURATION_SELECTED,
  RESET_SGC_CONFIGURATION_SELECTED,
  
  SET_CONFIG_PAGE_SGC_CONFIGURATIONS,
  SET_CONFIG_PAGE_SIZE_SGC_CONFIGURATIONS,
  SET_CONFIG_FILTER_SGC_CONFIGURATIONS,
  SET_CONFIG_SORTED_SGC_CONFIGURATIONS
} = ActionTypes

export const getSgcConfigurations = (station = {}) => {
  const url = `${process.env.REACT_APP_URL}/crm/sgc_configurations/station/${station?.id}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingSgcConfigurations'))
    await api_get(url).then(resp => {
      if (resp.length === 0) dispatch(setSnackbar('No se encontraron configuraciones'))
      dispatch({
        type: GET_SGC_CONFIGURATIONS,
        payload: resp
      })
    }).catch(error => dispatch(setSnackbar(error ? error : "Error contacte al administrador")))
    dispatch(stopRequestComp('loadingSgcConfigurations'))
  }
}

export const createNewSgcConfiguration = (form) => {
  const url = `${process.env.REACT_APP_URL}/crm/sgc_configurations`
  return async ( dispatch ) => {
    dispatch(startRequestComp('loadingSgcConfigurations'))
    await api_post(url, [form]).then(resp => {
      dispatch({
        type: CREATE_SGC_CONFIGURATION,
        payload: resp[0]
      })
      dispatch(setSnackbar('La configuración se ha guardardo con éxito', 'success'))
    }).catch(error => {
      return dispatch(setSnackbar(error ? error : "Error contacte al administrador"))
    })
    dispatch(stopRequestComp('loadingSgcConfigurations'))
  }
}

export const editSgcConfiguration = (form) => {
  const url = `${process.env.REACT_APP_URL}/crm/sgc_configurations`
  return async ( dispatch ) => {
  dispatch(startRequestComp('loadingSgcConfigurations'))
    await api_put(url, form).then(resp => {
      dispatch({
        type: MOD_SGC_CONFIGURATION,
        payload: resp
      })
      dispatch(setSnackbar('La configuración se ha modificado con éxito', 'success'))
    }).catch(error => dispatch(setSnackbar(error ? error : "Error contacte al administrador")))
    dispatch(stopRequestComp('loadingSgcConfigurations'))
  }
}

export const deleteSgcConfiguration = (form) => {
  const url = `${process.env.REACT_APP_URL}/crm/sgc_configurations`
  return async ( dispatch ) => {
  dispatch(startRequestComp('loadingSgcConfigurations'))
    await api_delete(url, form).then(resp => {
      dispatch({
        type: DELETE_SGC_CONFIGURATION,
        payload: resp
      })
      dispatch(setSnackbar('La configuración se ha eliminado con éxito', 'success'))
    }).catch(error => dispatch(setSnackbar(error ? error : "Error contacte al administrador")))
    dispatch(stopRequestComp('loadingSgcConfigurations'))
  }
}

export const setSgcConfigurationSnackBar = (msg) => ({
  type: OPEN_SGC_CONFIGURATION_SNACK,
  payload: msg
})

export const closeSgcConfigurationsSnackBar = () => ({
  type: CLOSE_SGC_CONFIGURATION_SNACK,
})

export const sgcConfigurationSelected = (id) => ({
  type: SGC_CONFIGURATION_SELECTED,
  payload: id
})

export const addSgcConfigurationsMode = () => ({
  type: ADD_SGC_CONFIGURATION_MODE,
})

export const editSgcConfigurationsMode = () => ({
  type: EDIT_SGC_CONFIGURATION_MODE,
})

export const deleteSgcConfigurationsMode = () => ({
  type: DELETE_SGC_CONFIGURATION_MODE,
})

export const resetSgcConfigurationSelected = () => ({
  type: RESET_SGC_CONFIGURATION_SELECTED
})

export const setSgcConfigurationsFilters = (key = "", data) => ({
  type: SET_SGC_CONFIGURATIONS_FILTERS,
  payload: { data, key }
})

export const clearSgcConfigurations = () => ({
  type: CLEAR_SGC_CONFIGURATIONS,
})

export const setConfigPageSgcConfigurations = (page) => ({
  type: SET_CONFIG_PAGE_SGC_CONFIGURATIONS,
  payload: page,
})

export const setConfigPageSizeSgcConfigurations = (pageSize) => ({
  type: SET_CONFIG_PAGE_SIZE_SGC_CONFIGURATIONS,
  payload: pageSize,
})

export const setConfigFilteredSgcConfigurations = (filter) => ({
  type: SET_CONFIG_FILTER_SGC_CONFIGURATIONS,
  payload: filter,
})

export const setConfigSortedSgcConfigurations = (sort) => ({
  type: SET_CONFIG_SORTED_SGC_CONFIGURATIONS,
  payload: sort,
})